export const USER_STORAGE_ID = 'user';
